import { QueryOperation, SearchQuery } from "../../code/search-query/search-query";
import { buildSearchQuery, comboboxValue, QueryFieldMapping } from "../../code/search-query/query-mapper";
import { DataColumn } from "../../controls/Data.default";
import { InputObject } from "../../controls/default";
import { Tag } from "antd";
import { Kpi } from "../../repository/data.default";
import { questionnaireStatusColor } from "../questionnaires/QuestionnairesView.default";

export interface KpisForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly shortDescription: string;
  readonly type: InputObject;
  readonly scoringMethod: InputObject;
}

export const kpisViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    // The questionnaire version that owns the KPI; only a Draft's KPIs can be changed.
    title: "Questionnaire",
    key: "questionnaireName",
    width: 280,
    sort: true,
    transform: (value: string, record: Kpi) => (value ? `${value} v${record.questionnaireVersion}` : "Not linked yet"),
  },
  {
    // Its own column, like the questionnaires grid: sharing a cell with a long name clipped the tag.
    title: "Version status",
    key: "questionnaireStatus",
    width: 130,
    sort: true,
    transform: (value: Kpi["questionnaireStatus"]) =>
      value ? <Tag color={questionnaireStatusColor(value)}>{value}</Tag> : "",
  },
  {
    title: "Short Description",
    key: "shortDescription",
    width: 192,
    sort: true,
  },
  {
    title: "Type",
    key: "type",
    width: 320,
    sort: true,
  },
  {
    title: "Scoring Method",
    key: "scoringMethod",
    width: 320,
    sort: true,
  },
  {
    title: "Questions Count",
    key: "targetedQuestionsCount",
    width: 320,
    sort: true,
    type: "badge",
  },
  {
    title: "Reports Count",
    key: "linkedReportsCount",
    width: 320,
    sort: true,
    type: "badge",
  },
];

const kpisQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "shortDescription", operation: QueryOperation.Contains },
  { formField: "type", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "scoringMethod", operation: QueryOperation.Equal, transform: comboboxValue },
];

export const mapKpisViewQuery = (values: KpisForm): SearchQuery =>
  buildSearchQuery(values, kpisQueryMappings);
